import React from 'react';
import classnames from 'classnames';

import InvisibleButton from './InvisibleButton';
import help_image from './assets/HELP.png';
import './HelpButton.css';

const HelpButton = ({visible, focus_ref=null, has_focus=false, on_select=null}) => {
	const button = visible ? <InvisibleButton
		focus_ref={focus_ref}
		has_focus={has_focus}
		on_select={on_select}
		width={112}
		height={200}
		left={0}
		top={0}
	/> : null;

	return <div className={classnames('HelpButton', {'HelpButton-hidden': !visible})}>
		<img src={help_image} alt="" />
		{button}
	</div>
}

export default HelpButton;


// WEBPACK FOOTER //
// ./src/HelpButton.js